export var DocsRoutes = {
    "/docs/{candidateState:.*}?user_id&speedy_expand_doc&brand_id&brandID&showOBDocumentsModal&prospect_id&custom_type_name&custom_type_id": {
        "enableUTM": true,
        "name": "appLayout.harriSH.docs",
        "params": {candidateState: ""},
        "dynamic": true,
        "showGlobalSearch": true,
        "component": "docsPage",
        "preventTimeTracking": true,
        "loginRequired": true,
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["docs", "employee_termination"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Documents"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk', loader: function () {
                    return import("./docs.module.js");
                }
            },
            {
                type: 'chunk', loader: function () {
                    return import("../../hmodules/right-to-work/right-to-work.module.js");
                }
            },
            {
                type: 'chunk', loader: () => {
                    return import("../../hmodules/trust-id/trust-id.module.js");
                }
            },
            {
                type: 'chunk', loader: function () {
                    return import("../../hmodules/pos-integration/pos-integration.module.js");
                }
            },
            {
                type: 'chunk', loader: function () {
                    return import("../../hmodules/on-boarding/on-boarding.module.js");
                }
             },
            {
                type: 'chunk', loader: () => {
                    return import("../../hmodules/recruitment-hub/recruitment-hub.module.js");
                }
            }
        ],
        "onEnter": ['$state', 'brandServices', 'hUser', '$filter', ($state, brandServices, hUser, $filter) => {
            if (hUser.isEmployer()) {
                brandServices.check(brandServices.SERVICES.ONBOARDING_JOURNEY, hUser.getUserContext().brand_id)
                    .then(function (isOnBoardingJourneyEnabled) {
                        if (isOnBoardingJourneyEnabled) {
                            if (hUser.isTopLevelContext()) {
                                Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                            } else {
                                $state.go("appLayout.harriSH.dashboard");
                            }
                        } else if (!hUser.isTopLevelContext()) {
                            UserAPI.getUserPolicies(hUser.getUserContext().brand_id).then((policies) => {
                                if (!policies?.services?.length || !policies.services.includes('ON_BOARDING')) {
                                    hAlert($filter("translate")("Oops!"),
                                        $filter("translate")("It seems that you don't have enough permissions to access document management, please contact the admin for further information") + "."
                                    );
                                    $state.go("appLayout.harriSH.dashboard");
                                }
                            })
                        }
                    })
                    .catch(function (err) {
                        console.error(err);
                    });
            }
        }],
        "onExit": [() => {
            $(".modal-backdrop").remove();
        }]
    },
    "/employment-profile?brand_id&conversation_id&conversation_group_id": {
        "name": "appLayout.harriSH.employmentProfile",
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["docs", "employee_termination"]
        },
        "route_dependencies": [
            {
                type: 'chunk', loader: function () {
                    return import("./docs.module.js");
                }
            }
        ]
    },
    "/tl-employment-profile": {
        "name": "appLayout.schedule.employmentProfile",
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["docs", "employee_termination"]
        },
        "route_dependencies": [
            {
                type: 'chunk', loader: function () {
                    return import("./docs.module.js");
                }
            }
        ]
    }
};
